import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'absolute top-0 w-fit max-w-[100%] -translate-y-1/2 rounded-[1000px] lg:max-w-208 lg:bg-white/50 lg:p-5 lg:backdrop-blur-[40px]',
    slider: '',
    container:
      'flex flex-row items-center justify-center gap-4 px-2 lg:gap-15 lg:px-0',
    claim: 'h-30 w-30 lg:h-37 lg:w-37'
  },
  variants: {
    isSubscribed: {
      true: {
        base: 'static translate-0'
      }
    }
  }
});
